import { Observable } from 'rxjs'
import { PositionComparison } from '../models/position-comparison.model'

/**
 * Seam between the Position Comparison sub-panel and the comparison endpoint (PVAL-26240),
 * mirroring the {@link FieldCatalogService} / {@link WorkbenchDataSource} seams. The panel binds
 * {@link HttpFlexPositionComparisonService}, which hits the real backend; the panel/sub-panel
 * providers array can be overridden with {@link MockFlexPositionComparisonService} for tests and
 * local development while the backend (PVAL-26240) is not yet deployed.
 */
export abstract class FlexPositionComparisonService {
  /**
   * Fetch the source-centric comparison for a single anchor row, identified by the source it
   * belongs to (e.g. `ENFUSION`) and its row id.
   *
   * When the anchor has no matched sources, the response degrades to a single (anchor) source with
   * an empty `comparisons` map — an anchor-only view, not an error.
   */
  abstract getComparison(
    source: string,
    rowId: string,
  ): Observable<PositionComparison>
}
